import { addToast } from '@app/components/various/Toasts';
import { getRequestInvoicePayment } from '@app/services/paymentsRepository';
import { embedPaymentScript } from '@app/utils/embedPaymentScript';
import { getResponseErrors } from '@app/utils/errors';
import { useMutation } from '@tanstack/react-query';
import { Invoice, Payments } from '@typings';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

interface MutationVariables {
  payment: Payments.PaymentRequest;
  identifiers: Invoice.InvoiceIdentifiers;
}

export const useRequestInvoicePayment = () => {
  const { t } = useTranslation(['invoices']);
  const mutationFn = async ({ payment, identifiers }: MutationVariables) => {
    return getRequestInvoicePayment(payment, identifiers);
  };

  const handleError = (error: AxiosError<Responses.Errors>) => {
    const [errorMessage] = getResponseErrors(error);
    addToast(t('invoices:request_payment_fail'), { description: errorMessage });
  };

  const handleSuccess = (data: Payments.FormObject) => {
    embedPaymentScript(data.formHtml);
  };

  return useMutation({
    mutationFn,
    onError: handleError,
    onSuccess: handleSuccess,
  });
};
